import { type Translate } from "@redotech/redo-i18n";
import {
  ShippingClaimDenialReason,
  ShippingClaimReason,
  ShippingClaimRequestedBy,
  ShippingClaimStatus,
  ShippingClaimType,
} from "@redotech/redo-package-protection-common/shipping-claims/shipping-claim";

export function getMerchantFacingClaimStatusLabel(
  status: string,
  t: Translate,
): string {
  switch (status) {
    case ShippingClaimStatus.REQUESTED:
      return t("Requested");
    case ShippingClaimStatus.SUBMITTED:
      return t("Submitted to carrier");
    case ShippingClaimStatus.PENDING_DOCS:
      return t("Pending documentation");
    case ShippingClaimStatus.CARRIER_UNSUBMITTED_MERCHANT_APPROVED:
    case ShippingClaimStatus.CARRIER_SUBMITTED_MERCHANT_APPROVED:
    case ShippingClaimStatus.APPROVED:
      return t("Approved");
    case ShippingClaimStatus.REJECTED:
      return t("Rejected");
    default:
      return status;
  }
}

export function getShippingClaimReasonLabel(
  reason: string,
  t: Translate,
): string {
  switch (reason) {
    case ShippingClaimReason.LATE:
      return t("Late", { context: "shipping claim reason" });
    case ShippingClaimReason.DAMAGED:
      return t("Damaged", { context: "shipping claim reason" });
    case ShippingClaimReason.LOST:
      return t("Lost", { context: "shipping claim reason" });
    case ShippingClaimReason.STOLEN:
      return t("Stolen", { context: "shipping claim reason" });
    default:
      return reason;
  }
}

export function getShippingClaimTypeLabel(type: string, t: Translate): string {
  switch (type) {
    case ShippingClaimType.OUTBOUND:
      return t("Outbound");
    case ShippingClaimType.RETURN:
      return t("Return", { context: "shipping claim type" });
    default:
      return type;
  }
}

export function getShippingClaimRequestedByLabel(
  requestedBy: string,
  t: Translate,
): string {
  switch (requestedBy) {
    case ShippingClaimRequestedBy.MERCHANT:
      return t("Merchant");
    case ShippingClaimRequestedBy.PROACTIVE:
      return t("Proactive");
    default:
      return requestedBy;
  }
}

export function getShippingClaimDenialReasonLabel(
  reason: string,
  t: Translate,
): string {
  switch (reason) {
    case ShippingClaimDenialReason.PACKAGE_DELIVERED:
      return t("Package delivered");
    case ShippingClaimDenialReason.INSUFFICIENT_DOCUMENTATION:
      return t("Insufficient documentation");
    case ShippingClaimDenialReason.OUTSIDE_FILING_WINDOW:
      return t("Outside filing window");
    case ShippingClaimDenialReason.VALUE_NOT_SUBSTANTIATED:
      return t("Value not substantiated");
    case ShippingClaimDenialReason.PROOF_OF_DELIVERY_MISSING:
      return t("Proof of delivery missing");
    case ShippingClaimDenialReason.NOT_COVERED_BY_SERVICE_LEVEL:
      return t("Not covered by service level");
    case ShippingClaimDenialReason.DUPLICATE_CLAIM:
      return t("Duplicate claim");
    case ShippingClaimDenialReason.CLAIM_ALREADY_PAID:
      return t("Claim already paid");
    case ShippingClaimDenialReason.OTHER:
      return t("Other", { context: "shipping claim denial reason" });
    default:
      return reason;
  }
}
